import React, { FC } from 'react';

interface TableHeaderLabelProps {
  children: React.ReactNode;
  showOpacity?: boolean;
}
const TableHeaderLabel: FC<TableHeaderLabelProps> = ({ children, showOpacity }) => {
  return <span className={`text-sm font-medium text-white ${showOpacity && 'text-opacity-50'}`}>{children}</span>;
};
export default TableHeaderLabel;
